import React from 'react'
import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.min.css'

import App from './containers/App'
import './styles/index.css'

ReactDOM.render(<App />, document.getElementById('root'))
